import Actions from '../action'

const initialState = {
    isLoading: false,
    error: false,
    orderList: {},
}
export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_ORDER_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.GET_ORDER_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                orderList: action.data,
                error: false
            };
        }
        case Actions.GET_ORDER_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
        default:
            return state;
    }

};